<template>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
<path d="M12 4.5L4 12.5M4 4.5L12 12.5" stroke="#E74C3C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>